import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';
import { ApiService } from '../shared/api.service';
import {Configuracion} from '../models/Configuracion';
import {Acceso} from '../models/Acceso';
import {Formulario} from '../models/Formulario';
import { NgxSpinnerService } from "ngx-spinner";
import {Router} from '@angular/router';
import {ImagePopupComponent} from '../image-popup/image-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);
  public accesos: Acceso[];
  public formularios: Formulario[];
  people: any[] = [
    {
      "name": "Douglas  Pace"
    },
    {
      "name": "Mcleod  Mueller"
    },
    {
      "name": "Day  Meyers"
    },
    {
      "name": "Aguirre  Ellis"
    },
    {
      "name": "Cook  Tyson"
    }
  ];

  constructor(
    private metaService:Meta,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.loadScript();
    this.spinner.show();
    this.accesos = this.apiService.configuracion.accesos;
    this.formularios = this.apiService.configuracion.formularios;
    this.spinner.hide();
  }

  ngOnInit() {
    this.titleService.setTitle('Trámites en Línea y Centro de Ayuda | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Bienvenido al Centro de Ayuda en línea de Metrogas. Ingresa acá y encuentra las instrucciones para la realización de trámites en la sucursal virtual del sitio web.' })
    this.metaService.addTag( { name:'google-site-verification', content:'Qh-5fmI3CFYSUO0OEDxnBwfsbEA_5hnNgAXis3z6Ad4' } );
    this.checkAndOpenImagePopup();
    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
    }
    //No Levanta chat
    // @ts-ignore
    $(document).ready(() => {
      // @ts-ignore
      setTimeout(() => { if(videsk){videsk.toggle(false);} }, 1000);
    });


    //@ts-ignore
    $('.videsk-top-container').css('display', '');
  }

  filtroEstadoFormulario(){
    return this.formularios.filter(x => x.estado === true );
  }


 checkAndOpenImagePopup(): void {
    const currentDate = new Date();
    //meses: enero:0 febrero:1... etc
    const startDate = new Date(2026, 8, 4);
    const endDate = new Date(2026, 8, 14, 8, 0, 0);
    if (currentDate >= startDate && currentDate <= endDate) {
      this.openImagePopup();
    }
  }

openImagePopup(): void {
  this.dialog.open(ImagePopupComponent, {
    panelClass: 'image-popup-dialog',
    maxWidth: 'none'
  });
}


  filtroEstadoAcceso(){
    return this.accesos.filter(x => x.estado === true);
  }


  loadSpinner(){
    this.spinner.show();
  }

  irAgendamiento() {
    location.href="./agendamiento-de-hora";
  }

  irAsistenteVirtual() {
    location.href="./asistente-virtual";
  }

  irSuscripcionBoleta() {
    location.href="./suscripcion-boleta-electronica";
  }

  irLectura() {
    location.href="https://lecturamedidormetrogas.cl/";
  }

  irPagaTuCuenta() {
    location.href="./paga-tu-cuenta";
  }

  irBeneficioCovid19() {
    location.href="./beneficio-clientes-vulnerables-covid19";
  }

  irDuplicadoBoleta() {
    location.href="./duplicado-boleta";
  }

  irRestriccionConvenios() {
    location.href="./restriccion-de-convenios";
  }

  irModificacionDatosComerciales() {
    location.href="./modificacion-datos-comerciales";
  }

  irNegociacionDeudaClientesResidenciales() {
    location.href="./negociacion-deuda-clientes-residenciales";
  }

  irNegociacionComunidad() {
    location.href="./negociacion-comunidades";
  }

  irNegociacionComunidadComercio() {
    location.href="./negociacion-comunidad-o-comercio";
  }

  irNegociacionComercio() {
    location.href="./negociacion-comercios";
  }

  irTrasladoMetrobolsa() {
    location.href="./traslado-metro-bolsa";
  }

  irPagoPorError() {
    location.href="./correcion-pago-por-error";
  }

  irPagoDoble() {
    location.href="./pago-doble";
  }

  irVentaReguladores() {
    location.href="./venta-reguladores";
  }

  irCambioNombreBoleta() {
    location.href="./cambio-nombre-boleta";
  }

  irContacto() {
    location.href="./contactenos";
    //location.href="http://www.metrogas.cl/centrodeayuda/index.php?controller=contact&seccion=1";
  }

  irTracking() {
    location.href="./tracking";
  }

  irClubMetrogas() {
    location.href="https://www.clubmetrogas.cl/";
  }

  handleRedirect( url ){
    if ( url.indexOf( 'http' ) !== -1){
      location.href = url;
    }else{
      this.router.navigate([url]);
    }
  }


  loadScript() {
    if (this.isBrowser) {
      const node = document.createElement('script');
      node.src = "https://assets.videsk.io/js/videsk-widget.min.js";
      node.setAttribute('videsk-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyYWMiOiI1ZjljNDAtYmM3YzUxLWYwMWFkYi1kMzUxOTgiLCJpYXQiOjE2MDQwNzU3MTF9.Cqhq2zEbR2M3tnsOGfWMuDiASjnhDsFKO8pN9WHsub4');
      document.getElementsByTagName('body')[0].appendChild(node);
    }
  }


}
